module.exports = __webpack_public_path__ + "static/media/logokcvs.835935ea.png";